import { BrazeContentCard } from "../../Hooks/Braze/useBrazeContentCards"

export const getContentCardByLocation = (contentCards: BrazeContentCard[], location: string) => {
  if (!contentCards?.length) return null
  return contentCards.find((card) => {
    const cardLocations = convertCardLocations(card.extras?.location as string)
    return cardLocations.some((cardLocation) => cardLocation === location)
  })
}

const convertCardLocations = (locationString?: string): string[] => {
    if (!locationString) return []
    return locationString.split(',').map(loc => loc.trim())
  }